import { Link, Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { Icon } from '@swf/sports/components';
import FormattedDateTime from '@swf/sports/components/FormattedDateTime/FormattedDateTime';

import type { EventDynamicBanner, ImageFetchProps } from '../../../../model/types';
import BannerImage from '../../../BannerImage/BannerImage';

import { TXTWCL_Bet_Builder, TXTWCL_Build_your_bet_here } from './BetBuilder.messages.json';
import styles from './BetBuilder.scss';

const BetBuilderDynamicBanner: React.FC<EventDynamicBanner & ImageFetchProps> = ({
  image,
  event: { eventName, eventId, eventSlug, eventStartTime },
  eventType: { eventTypeId, eventTypeSlug },
  competition: { competitionId, competitionName, competitionSlug },
  slug,
  priority
}) => {
  const { formatMessage } = useRegulatoryIntl();

  return (
    <div className={styles.container}>
      <BannerImage image={image} priority={priority} />
      <div className={styles.inner}>
        <div className={styles.heading}>
          <div className={styles.iconContainer}>
            <div className={styles.background} />
            <Icon
              name="bet-builder"
              label={formatMessage(TXTWCL_Bet_Builder)}
              className={styles.icon}
              size="sm"
            />
          </div>
          <Translation {...TXTWCL_Bet_Builder} />
        </div>
        <div className={styles.eventName}>{eventName}</div>
        <div className={styles.competitionWithDate}>
          {competitionName}
          {', '}
          <FormattedDateTime date={eventStartTime} format="short" hideTime />
        </div>
        <div className={styles.time}>
          <Icon name="in-play" size="x1" />
          <FormattedDateTime date={eventStartTime} format="short" />
        </div>
        <div className={styles.linkContainer}>
          <Link
            className={styles.link}
            alias="sportsEvent"
            values={{
              competitionId,
              competitionSlug,
              eventId,
              eventSlug,
              eventTypeId,
              eventTypeSlug
            }}
            hash={slug}
          >
            <Translation {...TXTWCL_Build_your_bet_here} />
          </Link>
          <Icon className={styles.chevron} name="chevron-medium-right" size="lg" />
          <Icon
            className={classNames(styles.chevron, styles.chevronRight)}
            name="chevron-medium-right"
            size="lg"
          />
        </div>
      </div>
    </div>
  );
};

export default BetBuilderDynamicBanner;
